import React from "react";
import styled from "styled-components";
import Fade from "react-reveal/Fade";

const Section = ({
  id,
  title,
  description,
  bgImg,
  leftBtnText,
  rightBtnText,
}) => {
  console.log(id);
  return (
    <>
      <Wrap bgIMg={bgImg} id={id}>
        <ItemText>
          <p className="title">{title}</p>
          <p>{description}</p>
        </ItemText>
        <Buttons>
          <Fade bottom>
            <ButtonsGroup>
              <LeftButton>
                <p>{leftBtnText}</p>
              </LeftButton>
              {rightBtnText !== "" ? (
                <RightButton>
                  <p>{rightBtnText}</p>
                </RightButton>
              ) : (
                ""
              )}
            </ButtonsGroup>
          </Fade>
          <ArrowDown src="images/down-arrow.svg" />
        </Buttons>
      </Wrap>
    </>
  );
};

export default Section;

const Wrap = styled.div`
  width: 100%;
  height: 100vh;
  background-image: ${(props) => `url("/images/${props.bgIMg}")`};

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between; ;
`;

const ItemText = styled.div`
  margin-top: 20vh;
  p.title {
    font-size: 27px;
    font-weight: 600;
  }
`;

const Buttons = styled.div``;

const ButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const LeftButton = styled.div`
  width: 220px;
  height: 45px;
  background-color: #202125;
  opacity: 0.85;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  margin: 7px;
  cursor: pointer;
  p {
    color: #fff;
  }
`;
const RightButton = styled(LeftButton)`
  background-color: white;
  color: black;
  opacity: ;
  p {
    color: #393c41;
  }
`;

const ArrowDown = styled.img`
  margin-top: 20px;
  height: 35px;
  animation: updown infinite 1.5s;
`;
